<template>
    <div class="form">
        <Form :label-width="65">
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="房源名称: ">
                        {{
                            `${room.parkName}${room.floorName}${room.houseNum}`
                        }}
                    </FormItem>
                </Col>

                <Col span="12">
                    <FormItem label="客户姓名: ">{{ room.cusName }}</FormItem>
                </Col>
            </Row>
            <Row>
                <Table
                    ref="mt"
                    :height="mtHeight"
                    :editMode="editMode"
                    :formula="formula"
                    :columns="columns"
                    :data="page.list"
                    :loading="loading"
                    @on-select="mark"
                    @on-select-cancel="cancelMark"
                    @on-select-all="selectionChange"
                >
                    <template v-slot:readingStatus="{ row }">
                        <tag-status
                            :text="dict.readingStatus.val(row.readingStatus)"
                            :color="
                                row.readingStatus == 1
                                    ? 'rgb(114,183,6)'
                                    : 'rgb(127,142,241)'
                            "
                            :background="'rgb(243,249,233)'"
                            circle
                        />
                    </template>

                    <template v-slot:dosage="{ row }">
                        {{
                            row.dosage
                                ? row.dosage +
                                  `${
                                      hashsMap[
                                          dict.meterType.val(row.meterType)
                                      ]
                                  }`
                                : "0" +
                                  `${
                                      hashsMap[
                                          dict.meterType.val(row.meterType)
                                      ]
                                  }`
                        }}
                    </template>

                    <template v-slot:price="{ row }">
                        {{ (row.price / 100) | currency }}
                        {{ hashsMap[dict.meterType.val(row.meterType)] }}
                    </template>

                    <template v-slot:amount="{ row }">
                        {{ (row.amount / 100) | currency }}
                    </template>
                </Table>
            </Row>
        </Form>
        <div class="card-bottom">
            <table-pager
                :total="page.totalCount"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.pageNo"
                @change="fetch"
            >
            </table-pager>
        </div>
        <!-- 没有选中的提示框 -->
        <alter :text="modalMsg" v-model="alterShow" @closeAlter="closeAlter" />
        <div class="fixBtn">
            <Col :span="12">
                <Button
                    type="primary"
                    style="float: right; margin-right: 10px"
                    :loading="loading"
                    @click="onConfirmBtnClick"
                    >确定</Button
                >
            </Col>
            <Col :span="12">
                <Button
                    :disabled="disabled"
                    @click="onCancelBtnClick"
                    style="margin-left: 10px"
                    >取消</Button
                >
            </Col>
        </div>
    </div>
</template>

<script>
import { readingList, readingMeter } from "@/api/bill-list";
import Dict from "_u/dict";
import TagStatus from "_vc/tag-status";
import Alter from "_v/components/alter";
import { editCell } from "_c/grid/renderCell";
const PAGE_SIZE = 20;
export default {
    name: "MeterForm",
    inject: {
        $modal: {
            default: null,
        },
    },
    props: {
        room: {
            type: Object,
            default: () => ({}),
        },
    },
    components: {
        TagStatus,
        Alter,
    },
    data() {
        return {
            filter: {
                pageNo: 1,
                pageSize: PAGE_SIZE,
                houseId: this.room.id,
                meterTypes: "1,2,3",
                belongMonth:
                    new Date().getFullYear().toString() +
                    "-" +
                    (new Date().getMonth() + 1).toString(),
                cusName: "", //this.room.cusName
                readingStatus: "",
            },
            mtHeight: 360,
            page: {
                totalCount: 0,
                list: [],
            },
            editMode: "row",
            dict: {
                meterType: Dict.NULL,
                readingStatus: Dict.NULL,
            },
            selectionList: [], // 当前选中项
            alterShow: false, // 是否显示弹出框
            modalMsg: "", // 提示框内容
            selectList: [], // 要提交的选中项
            list: [],
            hashMap: {
                水表: "吨",
                电表: "度",
                燃气表: "立方米",
            },
            hashsMap: {
                水表: "元/吨",
                电表: "元/度",
                燃气表: "元/立方米",
            },
            modal: { Show: false },
            loading: false,
            disabled: false,
        };
    },
    methods: {
        fetch() {
            this.loading = true;
            // sMeterList({ page: 1, pageSize: 999 })
            //     .then((res) => {
            //         let list = res.data.page.list;
            //         let filterMeterType = [];
            //         list.map((v) => {
            //             if (v.enabled !== 0) {
            //                 filterMeterType.push(v.meterType);
            //             }
            //         });
            //         let newType = Array.from(new Set(filterMeterType));
            //         this.filter.meterTypes = newType.join();
            //     })
            //     .then(() => {
            Promise.all([
                readingList(this.filter),
                Dict.get(["meter_type", "reading_status"]),
            ])
                .then((args) => {
                    var [view, dictGroup] = args;
                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name];
                    });
                    this.setPageData(view);
                })
                .finally(() => {
                    this.loading = false;
                });
            // });
        },
        setPageData(res) {
            let list = res.data.page.list;
            list.forEach((i, index) => {
                i.check = false;
                i.onlyId = index;
                if (i.readingStatus == 1) {
                    i._disabled = true;
                    i.price = i.price;
                } else {
                    i._disabled = false;
                    i.price = i.settingPrice;
                }
                i.belongMonth
                    ? (i.belongMonth = i.belongMonth)
                    : (i.belongMonth = this.filter.belongMonth);
            });
            this.page.list = list;
            this.page.totalCount = parseInt(res.data.page.totalCount);
        },
        mark(selection, row) {
            this.page.list[row.onlyId].check = true;
        },
        cancelMark(selection, row) {
            this.page.list[row.onlyId].check = false;
        },
        // 取消
        closeModalInvalid() {
            this.modal.confirmShowInvalid = false;
        },
        // 全选
        selectionChange(selection) {
            let list = this.page.list.filter((i) => {
                return (i._disabled = false);
            });
            list.forEach((v) => {
                v.check = true;
            });
        },
        // 关闭 alter
        closeAlter() {
            this.alterShow = false;
        },
        formula(model) {
            var options = {
                immediate: true,
            };
            // 计算用量
            model.equation(
                (d) => d.key == "dosage",
                (d) => {
                    return d.row["degree"] - d.row["lastDegree"];
                },
                options
            );
            // 计算应收
            model.equation(
                (d) => {
                    return d.key == "amount";
                },
                (d) => {
                    return (
                        (d.row["degree"] - d.row["lastDegree"]) * d.row["price"]
                    );
                },
                options
            );
            // 校验
            model.verification(
                (d) => d.key == "degree",
                (d) => [
                    {
                        validator(rule, value, callback, source, options) {
                            var msg = "本次读数必填且大于上次读数";
                            if (d.row.check === true) {
                                if (
                                    d.row.degree &&
                                    d.row.degree > d.row.lastDegree
                                ) {
                                    return callback();
                                } else {
                                    return callback(new Error(msg));
                                }
                            }
                            return callback();
                        },
                    },
                ]
            );

            // 校验
            model.verification(
                (d) => d.key == "planDate",
                (d) => [
                    {
                        validator(rule, value, callback, source, options) {
                            var msg = "应收款日必填";
                            if (d.row.check === true) {
                                if (d.row.planDate) {
                                    return callback();
                                } else {
                                    return callback(new Error(msg));
                                }
                            }
                            return callback();
                        },
                    },
                ]
            );
        },
        onConfirmBtnClick() {
            let index = this.page.list.findIndex((i) => {
                return i.check === true;
            });
            if (index >= 0) {
                this.$refs.mt
                    .validate()
                    .then(() => {
                        let list = [];
                        list = this.page.list.filter((i) => i.check === true);
                        this.list = list;
                        readingMeter(JSON.stringify(this.list)).then(() => {
                            this.$Message.success("抄表生成成功");
                            this.$modal.close();
                            this.$modal.$emit(`close-by-confirm`);
                        });
                    })
                    .catch((err) => {
                        this.$Message.error(err[0].message);
                    });
            } else {
                this.modalMsg = "请至少选择一条记录再进行批量操作";
                this.alterShow = true;
                // options.closeModal = false;
            }
        },
        onCancelBtnClick() {
            this.$modal.close();
        },
    },
    computed: {
        columns() {
            return [
                { type: "selection", width: 60, align: "center" },
                {
                    type: "index",
                    width: 80,
                    title: "序号",
                    align: "center",
                },
                {
                    title: "表名称",
                    key: "meterName",
                    align: "left",
                    minWidth: 80,
                },
                {
                    title: "抄表状态",
                    key: "readingStatus",
                    align: "center",
                    minWidth: 120,
                    slot: "readingStatus",
                },
                {
                    title: "上次读数",
                    key: "lastDegree",
                    align: "right",
                    minWidth: 100,
                },
                {
                    title: "本次读数",
                    key: "degree",
                    align: "right",
                    minWidth: 100,
                    canEdit: ({ row, column, index }) => row.readingStatus == 2,
                    // 数字输入框
                    render: editCell("CellInputNumber", {
                        // 给InputNumber传递属性，注意attrs与props的区别
                        attrs: {
                            // 禁用小数
                            // allowDecimal: false,
                            // 禁用千分位
                            includeThousandsSeparator: false,
                            // 禁用负数
                            allowNegative: false,
                        },
                    }),
                },
                {
                    title: "用量",
                    key: "dosage",
                    align: "center",
                    minWidth: 120,
                    slot: "dosage",
                },
                {
                    title: "单价",
                    key: "price",
                    align: "center",
                    minWidth: 120,
                    slot: "price",
                },
                {
                    title: "应收(元)",
                    key: "amount",
                    align: "center",
                    minWidth: 80,
                    slot: "amount",
                },
                {
                    title: "应收款日",
                    key: "planDate",
                    align: "center",
                    minWidth: 150,
                    canEdit: ({ row, column, index }) => row.readingStatus == 2,
                    render: editCell("CellDatePicker"),
                },
            ];
        },
    },
    created() {
        this.fetch();
    },
    mounted() {
        // this.$modal.onBtnClick("confirm", (next, options) => {
        //     let index = this.page.list.findIndex((i) => {
        //         return i.check === true;
        //     });
        //     if (index >= 0) {
        //         this.$refs.mt.validate().then(() => {
        //             let list = [];
        //             list = this.page.list.filter((i) => i.check === true);
        //             this.list = list;
        //             readingMeter(JSON.stringify(this.list))
        //                 .then(() => {
        //                     this.$Message.success("抄表生成成功");
        //                     options.closeModal = true;
        //                 })
        //                 .catch((err) => {
        //                     options.closeModal = false;
        //                     this.$Message.error(err[0].message);
        //                 })
        //                 .finally(() => {
        //                     next();
        //                 });
        //         });
        //     } else {
        //         this.modalMsg = "请至少选择一条记录再进行批量操作";
        //         this.alterShow = true;
        //         // options.closeModal = false;
        //     }
        // this.$refs.mt
        //     .validate()
        //     .then(() => {
        //         let index = this.page.list.findIndex((i) => {
        //             return i.check === true;
        //         });
        // if (this.selectionList.length === 0) {
        //     this.modalMsg = "请至少选择一条记录再进行操作";
        //     this.alterShow = true;
        //     options.closeModal = false;
        // } else {
        //     let list = [];
        //     list = this.page.list.filter((i) => i.check === true);
        //     list.map((v) => {
        //         if (v.degree && v.planDate) {
        //             this.list = list;
        //             readingMeter(JSON.stringify(this.list)).then(
        //                 () => {
        //                     this.$Message.success("抄表生成成功");
        //                     options.closeModal = true;
        //                 }
        //             );
        //         } else {
        //             options.closeModal = false;
        //         }
        //     });
        // }
        // });
        // .catch((err) => {
        //     options.closeModal = false;
        //     this.$Message.success("选中的列表本次读数和应收款日必填");
        // })
        // .catch((err) => {
        //     options.closeModal = false;
        //     this.$Message.error(err[0].message);
        // })
        // .finally(() => {
        //     next();
        // });
        // });
    },
};
</script>

<style lang="less" scoped>
.fixBtn {
    width: 940px;
    position: absolute;
    bottom: 15px;
    background: rgb(255, 255, 255);
}
</style>